import { createSelector } from '@ngrx/store';

import { getSpeechState } from './speech-models.selectors';

export const getSpeechSelectedTab = createSelector(getSpeechState, state => state.page.selectedTab);
export const getSpeechPermission = createSelector(getSpeechState, state => state.page.permission);
